

 
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
 
const MaterialContracts = () => {
  const pageTitle = "Material Contracts";
 
  const tableData = [
    {
      type: "item",
      id: "1",
      description: "Offer Agreement",
      link: "/assets/pdf/Material_Contrats/1. Offer Agreement.pdf",
    },
    {
      type: "item",
      id: "2",
      description: "RTA Agreement",
      link: "/assets/pdf/Material_Contrats/2. RTA Agreement.pdf",
    },
    {
      type: "item",
      id: "3",
      description: "Underwriting Agreement",
      link: "/assets/pdf/Material_Contrats/3. Underwriting Agreement.pdf",
    },
    {
      type: "item",
      id: "4",
      description: "Market Maker Agreement",
      link: "/assets/pdf/Material_Contrats/4. Market Maker Agreement.pdf",
    },
    {
      type: "item",
      id: "5",
      description: "Syndicate Agreement",
      link: "/assets/pdf/Material_Contrats/5. Syndicate Agreement.pdf",
    },
    {
      type: "item",
      id: "6",
      description: "Cash Escrow Agreement",
      link: "/assets/pdf/Material_Contrats/6. Cash Escrow Agreement.pdf",
    },
    {
      type: "item",
      id: "7",
      description: "Monitoring Agency Agreement",
      link: "/assets/pdf/Material_Contrats/7. MA Agreement.pdf",
    },
    {
      type: "item",
      id: "8",
      description: "Tripartite NSDL Agreement",
      link: "/assets/pdf/Material_Contrats/8. Tripartite NSDL Agreement.pdf",
    },
    {
      type: "item",
      id: "9",
      description: "Tripartite CDSL Agreement",
      link: "/assets/pdf/Material_Contrats/9. Tripartite CDSL Agreement.pdf",
    },
  ];
  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
 
      <div className="main-content">
        <Header />
 
        {/* Banner */}
        <div
          className="relative h-[30vh] sm:h-[60vh] md:h-[50vh] lg:h-[70vh] w-full bg-no-repeat bg-cover bg-center mb-3"
          style={{
            backgroundImage: `url(/assets/img/Financial_banner.png)`,
          }}
        >
          <div className="absolute left-4 sm:left-8 md:left-12 top-1/2 transform -translate-y-1/2 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-normal text-white px-4 sm:px-8 md:px-20 font-serif">
            Material Contracts
          </div>
        </div>
 
        {/* Single Table */}
        <div className="w-[70%] mx-auto border border-gray-300">
          {/* Table Header */}
          <div className="bg-[#F26624] text-white text-sm font-medium py-2 px-1">
            <div className="flex">
              <div className="w-12 text-center border-r border-gray-300">
                S.No
              </div>
              <div className="flex-1 text-center border-r border-gray-300">
                Particular
              </div>
              <div className="w-24 text-center">Link</div>
            </div>
          </div>
 
          {/* Table Body */}
          {tableData.map((row, index) => {
            if (row.type === "section-header") {
              return (
                <div
                  key={index}
                  className={`${row.bgColor} text-white font-semibold text-sm px-4 py-2 border-b border-gray-300 ml-12`}
                >
                  {row.title}
                </div>
              );
            }
 
            if (row.type === "sub-header") {
              return (
                <div
                  key={index}
                  className={`${row.bgColor} text-white font-medium text-sm px-4 py-1 border-b border-gray-300 ml-12`}
                >
                  {row.title}
                </div>
              );
            }
 
            // Regular Item Row
            const isPdf = row.link && row.link.endsWith(".pdf");
            const showId = row.id && !row.isSubHeader;
 
            return (
              <div
                key={index}
                className="bg-white border-b border-gray-300 text-xs hover:bg-gray-50"
              >
                <div className="flex">
                  <div className="w-12 text-center border-r border-gray-300 py-2">
                    {showId ? row.id : ""}
                  </div>
                  <div
                    className={`flex-1 px-3 py-2 border-r border-gray-300 ${
                      row.isSubHeader ? "font-semibold text-red-600" : ""
                    }`}
                  >
                    {row.description}
                  </div>
                  <div className="w-24 flex items-center justify-center">
                    {isPdf ? (
                      <a
                        href={row.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[#F26624] hover:text-red-800 hover:underline text-sm font-semibold"
                      >
                        Click Here
                      </a>
                    ) : (
                      <button
                        onClick={() => alert("PDF link not available yet.")}
                        className="text-[#F26624] hover:text-red-800 hover:underline text-sm font-semibold"
                      >
                        Click Here
                      </button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
 
        <Footer />
      </div>
    </>
  );
};
 
export default MaterialContracts;
 
 